import Box from "@mui/joy/Box";
import { ReactNode } from "react";

export const RightPaneFrame = (props: { children?: ReactNode; sx?: any }) => {
  return (
    <Box
      sx={[
        {
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          justifyContent: "flex-start",
          alignItems: "stretch",
          gap: 1.5,
          m: 4,
          mt: 5,
        },
      ]}
      {...props}
    />
  );
};
